import { render } from "./SalesTargetChart.vue?vue&type=template&id=60fa76d6&ts=true"
import script from "./SalesTargetChart.vue?vue&type=script&lang=ts"
export * from "./SalesTargetChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__